export const TYPEV4 = 'TypeV4';
export const MIN_LENGTH = 'MinLength';
export const MAX_LENGTH = 'MaxLength';
export const MIN_ITEMS = 'MinItems';
export const MAX_ITEMS = 'MaxItems';
export const ENUM = 'Enum';
export const UNIQUE = 'Unique'; // FE generated error
export const PATTERN = 'Pattern';
export const FB = 'Facebook';
export const REQUIRED = 'Required';
export const BUTTON_DIALOGUE_DELETED = 'button_dialogue_deleted'; // FE generated error to fix BE data inconsistency
export const WRONG_SETTINGS = 'WrongSettings';
